"use client";

import { Typography } from "@/components/ui/typography";
import type { ServicesFAQProps } from "./types";
import { servicesFAQMap } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import {
  FaqStack,
  FaqLinkBlock,
} from "@/components/screen/global-components/faq";

const ServicesFAQ = ({ variant = "standard", className }: ServicesFAQProps) => {
  const { accordionItems, footerTitle } = servicesFAQMap[variant];

  return (
    <section className={cn("section", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="border-b border-gray-300">
          <Typography
            variant="heading4"
            className="text-semantic-text-primary md:text-gray-800"
            asChild
          >
            <h2>Frequently asked questions</h2>
          </Typography>
          <FaqStack items={accordionItems} className="mt-6" />
        </div>
        <FaqLinkBlock
          title={footerTitle}
          className="mt-6 py-4 sm:p-0"
        />
      </div>
    </section>
  );
};

export default memo(ServicesFAQ);
